import { IAccount } from '@GFTypes/GameStoreTypes/Account';

export const ACCOUNT_DEFAULTS: IAccount = {
    balance: {
        raw: 0,
        normalized: 0,
        formatted: ''
    },
    win: {
        raw: 0,
        normalized: 0,
        formatted: ''
    },
    bonuses: {},
    currency: {
        code: '',
        exponent: 0
    }
};
